import React from 'react';

import GrantsPage from '../components/GrantsPage';

const GrantsApp = (props) => (
  <GrantsPage {...props} />
);

export default GrantsApp;
